import logo from "../../assets/logo.svg";
import "./style.css";

const Footer = () => {
	return (
		<footer>
			<div className="container">
				<div className="row">
					<div className="col-md-4">
						<img src={logo} alt="logo" />
						<p className="description">
							FM 90 Valet System is an intelligent valet parking and vehicle
							management application designed to make parking faster, safer, and
							more convenient.
						</p>
						<div className="social">
							<a
								href="https://wa.me/+96590068722"
								target="_blank"
								rel="noreferrer">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="20"
									height="20"
									viewBox="0 0 432 432">
									<path
										fill="#B87332"
										d="M364.5 65Q427 127 427 214.5T364.5 364T214 426q-54 0-101-26L0 429l30-109Q2 271 2 214q0-87 62-149T214 3t150.5 62zM214 390q73 0 125-51.5T391 214T339 89.5T214 38T89.5 89.5T38 214q0 51 27 94l4 6l-18 65l67-17l6 3q42 25 90 25zm97-132q9 5 10 7q4 6-3 25q-3 8-15 15.5t-21 9.5q-18 2-33-2q-17-6-30-11q-8-4-15.5-8.5t-14.5-9t-13-9.5t-11.5-10t-10.5-10.5t-8.5-9.5t-7-8.5t-5.5-7t-3.5-5L128 222q-22-29-22-55q0-24 19-44q6-7 14-7q6 0 10 1q8 0 12 9q2 3 6 13l7 17.5l3 8.5q3 5 1 9q-3 7-5 9l-3 3l-3 3.5l-2 2.5q-6 6-3 11q13 22 30 37q13 11 43 26q7 3 11-1q12-15 17-21q4-6 12-3q6 3 36 17z"
									/>
								</svg>
							</a>

							<div className="separte"></div>
							<a
								href="https://www.instagram.com/fm90_valet_parking?igsh=MTkxYjdoOHM4OWptYQ=="
								target="_blank"
								rel="noreferrer">
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<g clip-path="url(#clip0_64_217)">
										<path
											d="M12 2C14.717 2 15.056 2.01 16.122 2.06C17.187 2.11 17.912 2.277 18.55 2.525C19.21 2.779 19.766 3.123 20.322 3.678C20.8305 4.1779 21.224 4.78259 21.475 5.45C21.722 6.087 21.89 6.813 21.94 7.878C21.987 8.944 22 9.283 22 12C22 14.717 21.99 15.056 21.94 16.122C21.89 17.187 21.722 17.912 21.475 18.55C21.2247 19.2178 20.8311 19.8226 20.322 20.322C19.822 20.8303 19.2173 21.2238 18.55 21.475C17.913 21.722 17.187 21.89 16.122 21.94C15.056 21.987 14.717 22 12 22C9.283 22 8.944 21.99 7.878 21.94C6.813 21.89 6.088 21.722 5.45 21.475C4.78233 21.2245 4.17753 20.8309 3.678 20.322C3.16941 19.8222 2.77593 19.2175 2.525 18.55C2.277 17.913 2.11 17.187 2.06 16.122C2.013 15.056 2 14.717 2 12C2 9.283 2.01 8.944 2.06 7.878C2.11 6.812 2.277 6.088 2.525 5.45C2.77524 4.78218 3.1688 4.17732 3.678 3.678C4.17767 3.16923 4.78243 2.77573 5.45 2.525C6.088 2.277 6.812 2.11 7.878 2.06C8.944 2.013 9.283 2 12 2ZM12 7C10.6739 7 9.40215 7.52678 8.46447 8.46447C7.52678 9.40215 7 10.6739 7 12C7 13.3261 7.52678 14.5979 8.46447 15.5355C9.40215 16.4732 10.6739 17 12 17C13.3261 17 14.5979 16.4732 15.5355 15.5355C16.4732 14.5979 17 13.3261 17 12C17 10.6739 16.4732 9.40215 15.5355 8.46447C14.5979 7.52678 13.3261 7 12 7ZM18.5 6.75C18.5 6.41848 18.3683 6.10054 18.1339 5.86612C17.8995 5.6317 17.5815 5.5 17.25 5.5C16.9185 5.5 16.6005 5.6317 16.3661 5.86612C16.1317 6.10054 16 6.41848 16 6.75C16 7.08152 16.1317 7.39946 16.3661 7.63388C16.6005 7.8683 16.9185 8 17.25 8C17.5815 8 17.8995 7.8683 18.1339 7.63388C18.3683 7.39946 18.5 7.08152 18.5 6.75ZM12 9C12.7956 9 13.5587 9.31607 14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2044 9 12 9Z"
											fill="#B87332"
										/>
									</g>
									<defs>
										<clipPath id="clip0_64_217">
											<rect width="24" height="24" fill="white" />
										</clipPath>
									</defs>
								</svg>
							</a>
						</div>
					</div>
					<div className="col-md-4 links">
						<p className="title">quick link</p>
						<div>
							<a href="#Home">Home</a>
							<a href="#About">About</a>
							<a href="#Features">Features</a>
							<a href="#Screenshot">Screenshot</a>
							<a href="#Privacy">Privacy</a>
						</div>
					</div>
					<div className="col-md-4">
						<p className="title">news letter</p>
						<p className="description">
							Subscribe our newsletter to get our latest update & news
						</p>
						<div className="subscribe-input">
							<input type="text" placeholder="Your email address" />
							<svg
								width="40"
								height="41"
								viewBox="0 0 40 41"
								fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<rect y="0.5" width="40" height="40" rx="5" fill="#B87332" />
								<g clip-path="url(#clip0_48_530)">
									<path
										d="M11 21.5001H17V19.5001H11V10.3461C11 10.2592 11.0227 10.1738 11.0657 10.0984C11.1088 10.0229 11.1708 9.95997 11.2456 9.91576C11.3204 9.87155 11.4054 9.84759 11.4923 9.84625C11.5791 9.84491 11.6649 9.86623 11.741 9.90811L30.203 20.0621C30.2814 20.1053 30.3468 20.1687 30.3923 20.2457C30.4378 20.3228 30.4618 20.4106 30.4618 20.5001C30.4618 20.5896 30.4378 20.6774 30.3923 20.7545C30.3468 20.8315 30.2814 20.8949 30.203 20.9381L11.741 31.0921C11.6649 31.134 11.5791 31.1553 11.4923 31.154C11.4054 31.1526 11.3204 31.1287 11.2456 31.0844C11.1708 31.0402 11.1088 30.9773 11.0657 30.9018C11.0227 30.8264 11 30.741 11 30.6541V21.5001Z"
										fill="white"
									/>
								</g>
								<defs>
									<clipPath id="clip0_48_530">
										<rect
											width="24"
											height="24"
											fill="white"
											transform="translate(8 8.5)"
										/>
									</clipPath>
								</defs>
							</svg>
						</div>
					</div>
				</div>
				<hr />
				<p className="power">
					© <a href="#Home">Cloudlift solutions</a> | All rights reserved
				</p>
			</div>
		</footer>
	);
};
export default Footer;
